import { MapBuilder, px, type Decor, type MapDef } from '../mapdef';

/**
 * The MRT station under Taipei Main Station: concourse with the route map, ticket gates, the EasyCard
 * top-up machine, then the platform with yellow standing lines, priority seats and screen doors.
 * (mrtMap, mrtRules and mrtRide live in objects4.ts; the EasyCard machine and priority seats in objectsXinyi.ts.)
 */
const W = 34;
const b = new MapBuilder(W, 12, ' ');
b.room(0, 0, W, 10, 'm');
b.fill(1, 8, W - 2, 1, 'e');
b.fill(1, 9, W - 2, 1, 'm');
b.fill(0, 10, W, 2, 'T');
b.fill(0, 3, 1, 2, 'D');

const at = (tx: number, ty: number) => ({ x: px(tx), y: px(ty) });

const decor: Decor[] = [
  { kind: 'adPanel', x: px(8), y: 2, w: px(3), wall: true, variant: 0 },
  { kind: 'xy_adWall', x: px(30) + 8, y: px(1) + 1, w: px(5) },
  { kind: 'xy_lineStrip', x: px(14), y: px(1) + 1, w: px(6) - 4 },
  { kind: 'xy_exitBoard', x: px(2), y: px(3) - 2 },
  { kind: 'escalator', ...at(23, 6), solid: { x: px(22), y: px(1), w: px(3), h: px(5) } },
  { kind: 'screenDoors', x: px(1), y: px(10), w: px(W - 2) },
  { kind: 'ticketGates', ...at(13, 6), w: px(8) },
  // Platform: standing lines on the floor, a hanging station-name board and a bench.
  { kind: 'xy_queue', x: px(19), y: px(9), w: px(W - 20) },
  { kind: 'xy_mrtName', x: px(28) + 8, y: px(8) },
  { kind: 'stationBench', x: px(25), y: px(8) - 2, w: 40, solid: { x: px(25) - 20, y: px(8) - 8, w: 40, h: 6 } },
  { kind: 'xy_pillarAd', x: px(20) + 8, y: px(8), solid: { x: px(20) + 3, y: px(8) - 4, w: 10, h: 4 } },
  { kind: 'xy_pillarAd', x: px(6) + 8, y: px(8), variant: 1, solid: { x: px(6) + 3, y: px(8) - 4, w: 10, h: 4 } },
];

export const mrt: MapDef = {
  id: 'mrt',
  w: b.w,
  h: b.h,
  rows: b.rows(),
  indoor: true,
  theme: { wallFace: '#eef2f4', wallLight: '#ffffff', wainscot: '#2f8fa8', wallTop: '#22303a' },
  doors: [{ tiles: [[0, 3], [0, 4]], to: 'taipei', arrive: { x: px(8), y: px(48) + 8, facing: 'down' } }],
  decor,
  areas: [{ key: 'mrt', rect: { x: 0, y: 0, w: px(W), h: px(12) } }],
  lights: [
    { x: px(6), y: px(4), r: 90, color: '240,250,255' },
    { x: px(13), y: px(4), r: 90, color: '240,250,255' },
    { x: px(20), y: px(4), r: 90, color: '240,250,255' },
    { x: px(28), y: px(4), r: 90, color: '240,250,255' },
    { x: px(13), y: px(9), r: 120, color: '220,240,255' },
    { x: px(27), y: px(9), r: 120, color: '220,240,255' },
  ],
};
